import { Injectable } from '@angular/core';
import { WebsiteServiceApiService } from 'src/app/shared/api/website-service-api.service';
import { WebContentDto } from './dto/web-content.dto';

@Injectable({
  providedIn: 'root',
})
export class WebContentServiceService {
  public constructor(private _apiService: WebsiteServiceApiService) {}

  public createWebContent(fileToUpload: File = null, webContent: WebContentDto): Promise<number> {
    const formData = new FormData();
    formData.append('webContent', JSON.stringify(webContent));
    if (fileToUpload) {
      formData.append('file', fileToUpload, fileToUpload.name);
    }
    return this._apiService.postRaw('/website/v2/WebContent', formData);
  }

  public updateWebContent(fileToUpload: File = null, webContent: WebContentDto): Promise<void> {
    const formData = new FormData();
    formData.append('webContent', JSON.stringify(webContent));
    if (fileToUpload) {
      formData.append('file', fileToUpload, fileToUpload.name);
    }
    return this._apiService.putRaw('/website/v2/WebContent', formData);
  }

  public getWebContentImageUrl() {
    return `${this._apiService.getBaseUrl()}/website/v2/WebContent/Image/Upload`;
  }

  public getWebContentProfileImageUrl(profileId: number) {
    return `${this._apiService.getBaseUrl()}/website/v2/WebContent/Image/Upload/${profileId}`;
  }
  public deleteWebContent(id: number): Promise<number> {
    return this._apiService.delete(`/website/v2/WebContent/${id}`);
  }

  public deleteWebContentAffCode(webContentAffCodeId: number): Promise<void> {
    return this._apiService.delete(`/website/v2/WebContentAffCode/${webContentAffCodeId}`);
  }
}
